import { oakBoxCss, OakBoxProps } from "@oaknational/oak-components";
import styled from "styled-components";

export const Blockquote = styled.blockquote<OakBoxProps>`
  ${oakBoxCss}
`;

export default Blockquote;
